import { isRxDocument, RxDocument } from 'rxdb';

import { Booking } from '@mopla/data-models';

/**
 * Compares two bookings to determine if they are functionally equal
 * @param booking1 First booking to compare
 * @param booking2 Second booking to compare
 * @returns True if the bookings are considered equal, false otherwise
 */
export const areBookingsEqual = (
	booking1: RxDocument<Booking> | Booking,
	booking2: RxDocument<Booking> | Booking
): boolean => {
	const booking1Data = isRxDocument(booking1)
		? (booking1 as RxDocument<Booking>).toJSON()
		: booking1;
	const booking2Data = isRxDocument(booking2)
		? (booking2 as RxDocument<Booking>).toJSON()
		: booking2;

	// Compare essential booking properties that exist in the Booking type
	const essentialProps: Array<keyof Booking> = [
		'bookingId',
		'bookingState',
		'bulkyLuggage',
		'checkedInScheduledLegs',
		'currencyCode',
		'passengerList',
		'paymentAmount',
		'paymentForm',
		'paymentState',
		'specialNeeds',
		'toddlerSeats',
	];

	for (const prop of essentialProps) {
		// If deep object comparison is needed, add special handling here
		if (prop === 'checkedInScheduledLegs' || prop === 'passengerList') {
			if (
				JSON.stringify(booking1Data[prop]) !==
				JSON.stringify(booking2Data[prop])
			) {
				return false;
			}
		} else if (booking1Data[prop] !== booking2Data[prop]) {
			return false;
		}
	}

	return true;
};
